import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { RiderService, AppDataService } from 'app/services';
import { Utils } from 'app/utils';
import { RiderVehicleTypeEnum, XpressDeliveryStatus } from 'app/models';
import * as moment from 'moment/moment';

enum MenuTab {
    InvoiceDetails = 1
}

@Component({
    selector: 'driver-payout-invoice',
    templateUrl: './driver-payout-invoice.component.html',
    styleUrls: ['./driver-payout-invoice.component.scss',
        '../../../../../../styles/sidebar.scss']
})
export class DriverPayoutInvoiceComponent implements OnInit {
    public id: number = 0;
    @Input()
    set _id(value: number) {
        if (value > 0) {
            this.id = value;
            this.getRiderInvoice();
        }
    }

    public isVisibleDisplayDriverPayoutInvoice: boolean = false;
    @Input()
    set _isVisibleDisplayDriverPayoutInvoice(value: boolean) {
        this.isVisibleDisplayDriverPayoutInvoice = value;
    }

    @Output() changedVisibleDisplayDriverPayoutInvoiceEmit = new EventEmitter<boolean>();
    changedVisibleDisplayDriverPayoutInvoice(increased: any) {
        this.changedVisibleDisplayDriverPayoutInvoiceEmit.emit(increased);
    }

    constructor(private messageService: MessageService,
        private riderService: RiderService, public appDataService: AppDataService) { }

    public menuTab = MenuTab;
    public activeTab: MenuTab = MenuTab.InvoiceDetails;
    public menuItems: MenuItem[] = [
        {
            label: 'Invoice Details',
            command: (e: any) => this.menuTabChange(MenuTab.InvoiceDetails)
        }
    ];

    public riderInvoice: any;
    public isLoading: boolean = true;

    ngOnInit(): void { }

    public getRiderInvoice() {
        this.isLoading = true;

        const dto = {
            Id: this.id,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };
        this.riderService.getRiderInvoice(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.isLoading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.riderInvoice = data;
                this.riderInvoice.Amount = `₱ ${this.riderInvoice.Amount}`;
                this.riderInvoice.PaidAmount = `₱ ${this.riderInvoice.PaidAmount}`;
                this.riderInvoice.AdjustedReceivedAmount = `₱ ${this.riderInvoice.AdjustedReceivedAmount}`;
                this.riderInvoice.FeesPaidAmount = `₱ ${this.riderInvoice.FeesPaidAmount}`;
                this.riderInvoice.CreatedDateTime = moment(this.riderInvoice.CreatedAt).format('D MMM YYYY, hh:mmA');
                this.riderInvoice.PaidDate = moment(this.riderInvoice.PaidAt).format('D MMM YYYY');

                this.isLoading = false;
            })
            .catch(err => {
                this.isLoading = false;
                throw err;
            });
    }

    public menuTabChange(menuTab: MenuTab) {
        this.activeTab = menuTab;

        if (this.activeTab === MenuTab.InvoiceDetails) {
            this.getRiderInvoice();
        }
    }

    cancel() {
        this.changedVisibleDisplayDriverPayoutInvoice(false);
    }

    getStatusColor(status: InvoiceStatus) {
        switch(status) {
            case InvoiceStatus.Completed: return '#1CBA70';
            case InvoiceStatus.Pending: return '#FFC043';
            case InvoiceStatus.Failed: return '#EB4236';
        }
    }
}

export enum InvoiceStatus {
    Completed = 'Completed',
    Pending = 'Pending',
    Failed = 'Failed'
}
